import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UserAccount } from "src/app/shared/models/user-account";
import { AuthService } from "../service/auth.service";

@Component({
  selector: "app-dialog-confirm",
  templateUrl: "./dialog-confirm.component.html",
  styleUrls: ["./dialog-confirm.component.sass"],
})
export class DialogConfirmComponent implements OnInit {
  title: string;
  message: string;
  currentUser: UserAccount;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel
  ) {
    this.currentUser = new UserAccount();
    this.currentUser = JSON.parse(sessionStorage.getItem("CurrentUser"));
  }

  ngOnInit() {}
  Logout() {
    this.dialogRef.close(1);
  }
  Reset() {
    this.dialogRef.close(0);
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {
  constructor(public title: string, public message: string) {}
}
